import React from "/vendor/react";
import { SvgIcon } from "/vendor/@material-ui/core";
import Bg from "./Bg";

interface Props {
  color: string;
}

const Icon = React.memo(({ color, ...props }: Props) => {
  return (
    <SvgIcon viewBox="0 0 64 64" {...props}>
      <Bg color={color}>
        <g transform="translate(3.8 5)" fill="none" fillRule="evenodd">
          <path
            fill="#486831"
            d="M48.4 7l-2.1 6.3L42 9zM52.9 19.9l-6 3v-6zM51.5 29.7l-4.6 5-2.1-5.7zM54 41.4l-5.7 3.5-.5-6zM54.1 52.3l-5.9 3.3-.3-6z"
          />
          <path
            d="M36 76c7.3 0 13.3-11.3 13.3-25.3 0-5.1-2.7-21.4-4-25.4-2.4-7-4.6 0-9.3 0-7.3 0-13.3 11.4-13.3 25.4 0 14 6 25.3 13.3 25.3z"
            fill="#538132"
          />
          <path
            d="M30.6 71.2c2.3 0 4.2-8.7 4.2-19.3 0-10.7-1.9-19.3-4.2-19.3-.9 0-3-.1-4.2 1.8a49.5 49.5 0 00-3 30.8c2 5.3 5.7 6 7.2 6z"
            fill="#81A964"
          />
          <path
            d="M34.2 32.6c7.7 0 13.9-6 13.9-13.3C48 12 41.9 6 34.2 6s-13.9 6-13.9 13.3c0 3.7 3.2 6 5.8 8.4 2.5 2.3 4.3 4.9 8.1 4.9z"
            fill="#538132"
          />
          <ellipse fill="#FFF" cx="22.7" cy="16.9" rx="2.4" ry="3.6" />
          <path
            fill="#EFEFEF"
            d="M8.2 31.4l-1.1-2.5 2.4.1zM11.8 31.4l-1-2.5 2.3.1zM15.5 30.2l-1.2-2.5h2.4zM4.6 31.4l-1.1-2.5 2.4.1z"
          />
          <path
            d="M19.3 33c4-1.6 8.3-3.9 8-4.5 0-.3 1.8-2.5.6-2.3-.9.2-.7-.5-2.8.7-.4.2-.2.8-.9 1.2a33 33 0 01-4.8 2.3L14.1 32c-2.3.6-4.9 1.2-5.1 1.5-1.9 2-1.9 2-1.7 2.3.3.7 8-1 12-2.7z"
            fill="#F297A9"
          />
          <path
            d="M16.4 29l10-2.1c2.9-.6 4.3 6.3 5.3 5.9 4.6-1.8-1-5.2-1.3-8.2-.3-2.5 1.8-10.5-1.8-11.6-.7-.2-1 3-2.2 3.2-3.3.3-9.3 2-11.8 2.2-8.3.9-13.8 3-13.3 7.3.4 4.3 6.9 4.1 15.1 3.3z"
            fill="#538132"
          />
          <path
            d="M21.5 36.2l12-3.6c4-1-1.4-1-1.7-2.4-.4-1.7 1.6-7.4-3.3-6-.4.2.5-4.5-1.1 2.7-.1.4-1 1.6-1.6 2-1 1-7.7 3.8-7.4 3.7 4.3-1.8-2.9 1.4-5.3 2-4.2 1.1-7.5.4-7.2 1.6.2 1 4.5 1.7 7.2 1.4 2.6-.4 4.8-.6 8.4-1.4z"
            fill="#538132"
          />
          <ellipse fill="#FFF" cx="33.6" cy="16.9" rx="2.4" ry="3.6" />
          <path fill="#486831" d="M35.5 1.2l2.8 6.1-6-.2z" />
          <circle fill="#486831" cx="11.3" cy="22.3" r="1.8" />
          <circle fill="#486831" cx="4" cy="21.1" r="1.8" />
        </g>
      </Bg>
    </SvgIcon>
  );
});
Icon.displayName = "Avatar.Croc";

export default Icon;
